export const unitTranslations: Record<string, string> = {
  gram: 'گرم',
  kilogram: 'کیلوگرم',
  number: 'عدد',
  box: 'جعبه',
  seedling: 'اصله',
};

export const formulationTranslations: Record<string, string> = {
  liquid: 'مایع',
  solid: 'جامد',
  granule: 'گرانول',
};
